import { PageCardDisputeApiResponse } from './ApiResponse';
import { PageCardDispute } from './CardDispute';
import { PageCardDisputeEvidence } from './Evidence';
import { PageCardDisputeInformation } from './Information';
import { PageCardDisputes } from './Overview';

export { PageCardDisputes } from './Overview';
export { PageCardDispute } from './CardDispute';
export { DisputeEvidenceComposer, type DisputeEvidenceComposerProps } from './Evidence/index';

export const CARD_DISPUTES = {
  CardDisputes: PageCardDisputes,
  CardDisputeSection: PageCardDispute,
  CardDisputeInformation: PageCardDisputeInformation,
  CardDisputeEvidence: PageCardDisputeEvidence,
  CardDisputeApiResponse: PageCardDisputeApiResponse,
} as const;
